module.exports = __webpack_public_path__ + "img/light_turner_dead.e6d3ca20.png";